<template>
  <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
    <template slot="header">
      <div class="col-8">
        <h4 class="card-title">Veri Kalitesi Uyarıları</h4>
        <p class="card-category">Eksik tanımlanmış kumbara ve segmentler</p>
      </div>
      <div style="text-align: right;" class="col-4 card-title">
        <a-button icon="download" @click="exportCsv" :disabled="!hasAnyIssue">
          Excel'e Aktar
        </a-button>
      </div>
    </template>

    <div v-if="!report">Yükleniyor...</div>
    <div v-else>
      <a-collapse :default-active-key="['1']">
        <a-collapse-panel key="1" :header="'Boşaltma aralığı tanımlanmamış (' + report.missing_interval.length + ')'">
          <a-table
            rowKey="moneybox_id"
            size="small"
            :columns="moneyboxColumns"
            :data-source="report.missing_interval"
            :pagination="{ pageSize: 5 }"
          />
        </a-collapse-panel>
        <a-collapse-panel key="2" :header="'İşletme ataması eksik (' + report.missing_corporation.length + ')'">
          <a-table
            rowKey="moneybox_id"
            size="small"
            :columns="moneyboxColumns"
            :data-source="report.missing_corporation"
            :pagination="{ pageSize: 5 }"
          />
        </a-collapse-panel>
        <a-collapse-panel key="3" :header="'Hiç boşaltılmamış (' + report.never_unloaded.length + ')'">
          <a-table
            rowKey="moneybox_id"
            size="small"
            :columns="moneyboxColumns"
            :data-source="report.never_unloaded"
            :pagination="{ pageSize: 5 }"
          />
        </a-collapse-panel>
        <a-collapse-panel key="4" :header="'Yöneticisi olmayan segmentler (' + report.segments_without_admin.length + ')'">
          <a-table
            rowKey="segment_id"
            size="small"
            :columns="segmentColumns"
            :data-source="report.segments_without_admin"
            :pagination="{ pageSize: 5 }"
          />
        </a-collapse-panel>
      </a-collapse>
    </div>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },
  computed: {
    ...mapState({
      report: (state) => state.Reports.data_quality,
    }),
    hasAnyIssue() {
      if (!this.report) return false
      return (
        this.report.missing_interval.length ||
        this.report.missing_corporation.length ||
        this.report.never_unloaded.length ||
        this.report.segments_without_admin.length
      )
    },
  },
  mounted() {
    this.$store.dispatch('Reports/requestDataQuality')
  },
  methods: {
    exportCsv() {
      const rows = []
      const push = (list, issueLabel) => {
        list.forEach((item) => rows.push({
          uyari: issueLabel,
          ad: item.moneybox_name || item.segment_name,
          kod: item.moneybox_code || '',
          isletme: item.corporation_name || '',
          segment: item.segment_name || item.segment_type_name || '',
        }))
      }
      push(this.report.missing_interval, 'Boşaltma aralığı eksik')
      push(this.report.missing_corporation, 'İşletme ataması eksik')
      push(this.report.never_unloaded, 'Hiç boşaltılmamış')
      push(this.report.segments_without_admin, 'Yöneticisi olmayan segment')

      this.$exportToCsv(
        'veri_kalitesi_uyarilari',
        [
          { title: 'Uyarı Tipi', key: 'uyari' },
          { title: 'Ad', key: 'ad' },
          { title: 'Kod', key: 'kod' },
          { title: 'İşletme', key: 'isletme' },
          { title: 'Segment', key: 'segment' },
        ],
        rows
      )
    },
  },
  data() {
    return {
      moneyboxColumns: [
        { title: 'Kumbara', dataIndex: 'moneybox_name', key: 'moneybox_name' },
        { title: 'Kod', dataIndex: 'moneybox_code', key: 'moneybox_code' },
        { title: 'İşletme', dataIndex: 'corporation_name', key: 'corporation_name' },
        { title: 'Segment', dataIndex: 'segment_name', key: 'segment_name' },
      ],
      segmentColumns: [
        { title: 'Segment', dataIndex: 'segment_name', key: 'segment_name' },
        { title: 'Tip', dataIndex: 'segment_type_name', key: 'segment_type_name' },
      ],
    }
  },
}
</script>
